<template>
  <div class="max-w-xs mx-auto">
    <div class="relative flex items-center max-w-[8rem]">
      <button
        ref="decrement" type="button"
        :disabled="disabled"
        class="bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded-s-lg p-2 h-11 focus:ring-gray-100 focus:ring-2 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <svg
          class="w-3 h-3 text-gray-900" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
          viewBox="0 0 18 2"
        >
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1h16" />
        </svg>
      </button>
      <input
        ref="input" type="text" :value="value"
        :disabled="disabled"
        aria-describedby="helper-text-explanation"
        class="bg-gray-50 border-x-0 border-gray-300 h-11 text-center text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full py-2 disabled:opacity-50 disabled:cursor-not-allowed"
        required
      />
      <button
        ref="increment" type="button"
        :disabled="disabled"
        class="bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded-e-lg p-2 h-11 focus:ring-gray-100 focus:ring-2 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <svg
          class="w-3 h-3 text-gray-900" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
          viewBox="0 0 18 18"
        >
          <path
            stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M9 1v16M1 9h16"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script setup>
import { InputCounter } from "flowbite";
import { onMounted, ref, watch } from "vue";

const input = ref(null);
const increment = ref(null);
const decrement = ref(null);
const props = defineProps({
  elementId: {
    type: String,
    default: "el-id",
  },
  quantity: {
    type: Number,
    default: 0,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  value: {
    type: Number,
    default: 0,
  },
});
const emit = defineEmits(["qtyChange"]);
const options = {
  minValue: 0,
  onDecrement: () => {
    if (!props.disabled) {
      emit("qtyChange", input.value.value);
    }
  },
  onIncrement: () => {
    if (!props.disabled) {
      emit("qtyChange", input.value.value);
    }
  },
};
const instanceOptions = {
  id: props.elementId,
  override: true,
};

onMounted(() => {
  new InputCounter(
    input.value,
    increment.value,
    decrement.value,
    options,
    instanceOptions,
  );
});

// Watch for external value changes (e.g., when reset to 0)
watch(() => props.value, (newValue) => {
  if (input.value) {
    input.value.value = newValue;
  }
});
</script>
